<template>
  <v-form :lazy="true" @submit.prevent>
    <h2>Disclosure Events & Bankruptcies</h2>
    <p class="help">Choose the most accurate answer</p>

    <label>Loan with bankruptcies in the 7 years</label>
    <v-select
      :items="items"
      :value="product.hasRegulatoryIssues || false"
      @change="$emit('change', { field: 'hasRegulatoryIssues', value: $event })"
      solo />

    <label>Loan with financial related disclosure events</label>
    <v-select
      :items="items"
      :value="product.hasDisclosureEvents || false"
      @change="$emit('change', { field: 'hasDisclosureEvents', value: $event })"
      solo />

  </v-form>
</template>

<script>
export default {
  name: 'SectionDisclosures',
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    items: [
      { value: false, text: 'No' },
      { value: true, text: 'Yes' },
    ],
  }),
}
</script>

<style lang="scss" scoped>
.v-input.v-select {
  width: 150px;
}
</style>
